import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"

export default function ImgCard({ property, data }) {
  if (data) {
    return (
      <div className="container mx-auto pl-2 lg:pl-8 grid grid-cols-12">
        <div className="col-span-12 lg:col-span-9">
          {data.headerImage && (
            <GatsbyImage
              image={
                data.headerImage.asset && data.headerImage.asset.gatsbyImageData
              }
              // alt={data.name}
              alt={data.name}
              className="w-full object-cover h-72 md:h-96"
            />
          )}
        </div>
        <div className="col-span-12 lg:col-span-3 h-72 md:h-96 bg-gray-50"></div>
      </div>
    )
  }
  return (
    property && (
      <div className="pl-2 lg:pl-8 container mx-auto grid grid-cols-12">
        <div className="col-span-12 xl:col-span-9">
          <GatsbyImage
            image={property.image.asset && property.image.asset.gatsbyImageData}
            // alt={property.name}
            alt={property.name}
            className="w-full object-cover h-72 md:h-96"
          />
        </div>
        <div className="col-span-12 xl:col-span-3 h-auto xl:h-96 bg-gray-50"></div>
      </div>
    )
  )
}
